import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Gallery from "@/components/sections/Gallery";
import Trust from "@/components/sections/Trust";
import Testimonials from "@/components/sections/Testimonials";
import QuoteForm from "@/components/sections/QuoteForm";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="bg-[#0a0a0a] text-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Process />
        <Gallery />
        <Trust />
        <Testimonials />
        <QuoteForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
